import RSA from 'jsrsasign';

import { GlobalAPIService } from '@core';
import { logError } from '@utils';

export const generateKeyPair = () =>
  RSA.KEYUTIL.generateKeypair('EC', 'secp256r1');

export const generateId = ({
  pubKeyObj,
}: {
  prvKeyObj: RSA.KJUR.crypto.ECDSA;
  pubKeyObj: RSA.KJUR.crypto.ECDSA;
}) => {
  const pubKeyPEM = RSA.KEYUTIL.getPEM(pubKeyObj);
  const patientId = RSA.KEYUTIL.getKeyID(pubKeyPEM);
  return patientId;
};

export const generateCsr = (
  patientUUID: string,
  privateKeyPEM: string,
  publicKeyPEM: string
) => {
  const sigalg = 'SHA256withECDSA';
  const csrSubject = `/C=US/O=Oncare/CN=${patientUUID}`;
  const csr = new RSA.KJUR.asn1.csr.CertificationRequest({
    subject: { str: csrSubject },
    sbjpubkey: publicKeyPEM,
    sigalg,
    sbjprvkey: privateKeyPEM,
  });
  return csr.getPEM();
};

export const generateCertificate = async (patientUUID: string, csr: string) => {
  try {
    const data = { patientUuid: patientUUID, csr };
    const {
      data: { certificate },
    } = await GlobalAPIService.generateCertificate(data);
    return certificate;
  } catch (e) {
    logError(e);
    return '';
  }
};
